@if ($isDevMode | async) {
  <div class="absolute bg-red-600 p-8 z-50 bottom-0 left-0 text-white">
    Developer mode
  </div>
}
<router-outlet></router-outlet>
